import { render, staticRenderFns } from "./Index-news.vue?vue&type=template&id=20f947d8&scoped=true"
import script from "./Index-news.vue?vue&type=script&lang=js"
export * from "./Index-news.vue?vue&type=script&lang=js"
import style0 from "./Index-news.vue?vue&type=style&index=0&id=20f947d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f947d8",
  null
  
)

export default component.exports